export const getLanguageCode = () => {
  const language = localStorage.getItem("I18N_LANGUAGE");
  if (language === "pl") return 101;
  if (language === "de") return 102;
  return 103;
};

export const getCartItemIssueMessages = (item = {}) => {
  const details = item.validation_details || {};
  if (Array.isArray(details.messages) && details.messages.length) {
    return details.messages;
  }
  return item.validation_message ? [item.validation_message] : ["Ta pozycja wymaga ponownej weryfikacji."];
};

export const parsePermissions = (permissions) => {
  if (Array.isArray(permissions)) return permissions;
  if (typeof permissions !== "string") return [];

  try {
    const parsed = JSON.parse(permissions);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return permissions.split(",").map((p) => p.trim()).filter(Boolean);
  }
};
